import Image from "next/image";

import styles from '@styles/dropAuction/howItWork.module.scss';
import {useApp} from '@context/AppProvider';

const StepTwo = () => {
	const {convertCurrency} = useApp();
	return (
        <div className='col-sm-4'>
			<div className={styles.stepTwo}>
				<div className={styles.stepBidBox}>
					<Image
                        width={310}
                        height={310}
                        src='/assets/images/cricle-bg.png'
                        alt=''
                        style={{
                            maxWidth: "100%",
                            height: "auto"
                        }} />
					<div className={styles.stepBidTxt}>
						<div className={styles.stepNumber}>2</div>
						<div className={styles.stepBidInner}>
							<span>{convertCurrency(83.68)}</span>
							<Image
                                width={200}
                                height={83}
                                src='https://s3.us-west-004.backblazeb2.com/betterthat/index/shoe-200x83.png'
                                alt='shoe'
                                style={{
                                    maxWidth: "100%",
                                    height: "auto"
                                }} />
							<span className={styles.seeBtnAction}>Bid Now</span>
						</div>
					</div>
				</div>
				<div className={styles.stepText}>
					<h2>Bid</h2>
					<p>
						Enter the drop and when the price falls, bid and grab it before
						someone else does.
					</p>
					<p>
						Can&apos;t make the drop time? Place an offer before the auction
						starts and see if it is accepted.
					</p>
				</div>
			</div>
		</div>
    );
};

export default StepTwo;
